import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Col, Row } from 'react-styled-flexboxgrid'
import GatsbyImage from 'gatsby-image'
import mediumZoom from 'medium-zoom'

import { device, colors } from '../../styles/config'
import EventYoutubeVideo from './EventYoutubeVideo'
import EventInfo from './EventInfo'
import isMobile from '../../utils/isMobile'

const Event = ({
  name,
  time,
  eventType,
  description,
  details,
  video,
  image,
  gallery
}) => {
  useEffect(() => {
    mediumZoom('.gallery-image img', {
      background: 'rgba(36,41,70,0.95)',
      margin: isMobile ? 20 : 72
    })
  }, [])

  return (
    <Container>
      <Row>
        <Col xs={12} smOffset={3} sm={9} mdOffset={4} md={8}>
          <EventInfo
            name={name}
            time={time}
            eventType={eventType}
          />
        </Col>
      </Row>
      <Body>
        <MediaGrid xs={12} sm={3} mdOffset={1} md={3}>
          {image && <Image fluid={image.fluid}/>}
          {video && <EventYoutubeVideo {...video}/>}
        </MediaGrid>
        <Description
          xs={12}
          sm={6}
          md={5}
        >
          <div dangerouslySetInnerHTML={{ __html: description }}/>
          {gallery && gallery.length > 0 && (
            <Gallery>
              <h4>Gallery</h4>
              <GalleryGrid>
                {gallery.map((item, index) => {
                  if (item.model.name === 'Image') {
                    return (
                      <Image fluid={item.image.fluid} className="gallery-image" key={index}/>
                    )
                  } else if (item.model.name === 'Video') {
                    return <GalleryYoutubeVideo {...item.video} key={index}/>
                  }
                })}
              </GalleryGrid>
            </Gallery>
          )}
        </Description>
        <Details xs={12} sm={3} md={2}>
          <div>
            <div dangerouslySetInnerHTML={{ __html: details }}/>
            <Disclaimer>
            Das Mitbringen von eigenen Speisen & Getränken ist nicht gestattet.
            </Disclaimer>
          </div>
        </Details>
      </Body>
    </Container>
  )
}

const Container = styled.div`
  ${ props => props.theme.wrapper }
  margin: initial;
  max-width: initial;
  background: white;
  padding: 5rem;
  overflow: hidden;
  position: relative;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  @media ${ device.sm } {
    padding: 2rem;
  }
`

const Body = styled(Row)`
  margin-top: 3.5rem;
`

const MediaGrid = styled(Col)`
  display: grid;
  align-content: start;
  row-gap: 3.125rem;
  margin-bottom: 3.125rem;
`

const Image = styled(GatsbyImage)`
  width: 100%;
`

const Description = styled(Col)`
  line-height: 1.625;
  letter-spacing: 0.6px;
  white-space: pre-wrap;
  margin-top: -0.5rem;

  @media ${ device.sm } {
    margin-bottom: 3.125rem;
  }
`

const Details = styled(Description)`
  font-size: 0.875rem;
  letter-spacing: 0.53px;
  line-height: 1.85;
  
  > div {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`

const Gallery = styled.div`
  margin-top: 3.125rem;
`

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  row-gap: 1.5rem;
  column-gap: 1.5rem;
  margin-top: 1rem;
  
  @media ${ device.sm } {
    grid-template-columns: 1fr;
  }
`

const GalleryYoutubeVideo = styled(EventYoutubeVideo)`
  grid-column: 1 / -1;
`

const Disclaimer = styled.div`
  font-size: 0.875rem;
  letter-spacing: 0.53px;
  line-height: 1.85;
  position: relative;

  @media ${ device.sm } {
    margin-top: 3.125rem;
  }

  &:before {
    display: block;
      content: '';
      margin-bottom: 0.8125rem;
      width: 500px;
      height: 5px;
      background-color: ${ colors.highlight };
  }
`

export default Event
